import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import cs from "./cs.json";
import en from "./en.json";

// Language detection and persistence
const savedLang = localStorage.getItem("lang");
const browserLang = navigator.language?.startsWith("cs") ? "cs" : "en";

i18n
    .use(initReactI18next)
    .init({
        resources: {
            cs: { translation: cs },
            en: { translation: en },
        },
        lng: savedLang || browserLang || "cs",
        fallbackLng: "en",
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;